import { Icon } from "@uigovpe/components";
import type { ReactNode } from "react";

type Props = {
  children: ReactNode;
  title?: string;
};

export default function PerformanceHighlight({
  children,
  title = "Ótimo desempenho",
}: Props) {
  return (
    <div className="mt-6! flex! gap-3! rounded-lg! border! border-[#d4cef7]! bg-[#f6f2fc]! p-4! text-xs! text-[#4e3873]!">
      <Icon icon="info" outline className="shrink-0! text-[#4e3873]!" />
      <p className="m-0! leading-5! text-[#4e3873]!">
        <strong className="block!">{title}</strong>
        {children}
      </p>
    </div>
  );
}
